export const CategoryList:React.FC<CategoryList> = ({categoryList}) => {
    return (
        <>
        <section >
            <ul className="categoryItems">
                {categoryList.map((item,index) => (
                    <li key={index}  className="categoryItem">
                        <article>
                            <a href={item.url}>
                                <h3>{item.name}</h3>
                                <img src={`/images/article/${item.path}`} alt={item.name} width="174" height="116"/>
                            </a>
                        </article>
                    </li>
                ))}
            </ul>
        </section>
        </>
    )
}